import { render, staticRenderFns } from "./VerifyOtp.vue?vue&type=template&id=0fdb3ce2&scoped=true&"
import script from "./VerifyOtp.vue?vue&type=script&lang=js&"
export * from "./VerifyOtp.vue?vue&type=script&lang=js&"
import style0 from "./VerifyOtp.vue?vue&type=style&index=0&id=0fdb3ce2&media=screen&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb3ce2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VRow})
